// extracted by mini-css-extract-plugin
export var checkbox = "_3m-0";
export var circle = "_3m-3";
export var horizontalContainer = "_3m-7";
export var sm = "_3m-5";
export var switch0 = "_3m-2";
export var switchDisabled = "_3m-8";
export var switchEnabled = "_3m-1";
export var textSwitchContainer = "_3m-9";
export var textSwitchOption = "_3m-a";
export var textSwitchOptionSelected = "_3m-b";
export var verticalContainer = "_3m-6";
export var xs = "_3m-4";